import { PipeTransform } from '@angular/core';
var ReplaceLineBreakPipe = /** @class */ (function () {
    function ReplaceLineBreakPipe() {
    }
    ReplaceLineBreakPipe.prototype.transform = function (value, args) {
        return value.replace(/\n/g, '<br/>');
    };
    return ReplaceLineBreakPipe;
}());
export { ReplaceLineBreakPipe };
